(function () {
  var SOURCE = 'free-gift-auto-add';
  var syncInProgress = false;
  var pendingResync = false;
  var GIFTS = [];

  function loadConfig() {
    var el = document.getElementById('FreeGiftConfig');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function giftIds() {
    return GIFTS.map(function (gift) {
      return gift.variantId;
    });
  }

  function formatRupees(paise) {
    return '₹' + Math.round(paise / 100);
  }

  // Must mirror the rewards-gift-discount Function's qualifyingSubtotal
  // calc exactly: exclude exactly ONE unit's average price per
  // gift-eligible variant (summed across every line of that variant),
  // regardless of which specific line currently carries the discount.
  //
  // Tried excluding by "is this line currently discounted" instead
  // (item.original_line_price !== item.final_line_price) and it's circular:
  // once a gift line loses its discount for any reason (e.g. removing a
  // different line drops the subtotal below its tier), that line's own now
  // -full price gets counted back into qualifying spend, which can push the
  // subtotal back over the threshold and convince this script the tier is
  // still earned -- so the now-paid orphaned line never gets removed.
  // Confirmed live Aug 25: earn tote (₹400) + iron-on (₹600) via a genuine
  // extra tote purchase, then remove that extra tote -- the iron-on gift
  // line should revert to unearned and get removed, but instead sat there
  // permanently at full price, self-sustaining its own "earned" status.
  // Quantity/value based exclusion has no such dependency on discount state.
  function computeQualifyingSubtotal(cart) {
    var ids = giftIds();
    var total = 0;
    var byVariant = {};

    cart.items.forEach(function (item) {
      if (ids.indexOf(item.variant_id) === -1) {
        total += item.original_line_price;
        return;
      }
      if (!byVariant[item.variant_id]) {
        byVariant[item.variant_id] = { qty: 0, value: 0 };
      }
      byVariant[item.variant_id].qty += item.quantity;
      byVariant[item.variant_id].value += item.original_line_price;
    });

    Object.keys(byVariant).forEach(function (variantId) {
      var v = byVariant[variantId];
      if (v.qty <= 1) return; // entirely the free unit, contributes 0
      var unitPrice = v.value / v.qty;
      total += v.value - unitPrice;
    });

    return total;
  }

  // ---- Modals -------------------------------------------------------

  function ensureModalRoot() {
    var root = document.getElementById('FreeGiftModalRoot');
    if (root) return root;
    root = document.createElement('div');
    root.id = 'FreeGiftModalRoot';
    document.body.appendChild(root);
    return root;
  }

  function showCelebration(unlockedGifts) {
    var root = ensureModalRoot();
    var overlay = document.createElement('div');
    overlay.className = 'free-gift-modal free-gift-modal--celebrate';

    var giftsHtml = unlockedGifts
      .map(function (gift) {
        return (
          '<div class="free-gift-modal__gift">' +
          '<img class="free-gift-modal__gift-image" src="' +
          gift.image +
          '" alt="' +
          gift.name +
          '">' +
          '<span>' +
          gift.name +
          '</span>' +
          '</div>'
        );
      })
      .join('');

    var heading =
      unlockedGifts.length > 1
        ? 'Hooray! You unlocked ' + unlockedGifts.length + ' free gifts! 🎉'
        : 'Hooray! You unlocked a free gift! 🎉';

    overlay.innerHTML =
      '<div class="free-gift-modal__card">' +
      '<p class="free-gift-modal__title">' +
      heading +
      '</p>' +
      '<div class="free-gift-modal__gifts">' +
      giftsHtml +
      '</div>' +
      '<p class="free-gift-modal__sub">Already added to your cart ✨</p>' +
      '</div>';

    root.appendChild(overlay);
    requestAnimationFrame(function () {
      overlay.classList.add('free-gift-modal--visible');
    });

    setTimeout(function () {
      overlay.classList.remove('free-gift-modal--visible');
      setTimeout(function () {
        overlay.remove();
      }, 250);
    }, 2000);
  }

  function showCantRemoveInfo(gift) {
    var root = ensureModalRoot();
    var overlay = document.createElement('div');
    overlay.className = 'free-gift-modal free-gift-modal--info';

    overlay.innerHTML =
      '<div class="free-gift-modal__backdrop" data-free-gift-dismiss></div>' +
      '<div class="free-gift-modal__card">' +
      '<button type="button" class="free-gift-modal__close" data-free-gift-dismiss aria-label="Close">&times;</button>' +
      '<img class="free-gift-modal__gift-image free-gift-modal__gift-image--large" src="' +
      gift.image +
      '" alt="' +
      gift.name +
      '">' +
      '<p class="free-gift-modal__title">This one\'s on us! 🎁</p>' +
      '<p class="free-gift-modal__body">Your ' +
      gift.name +
      ' is a free gift for shopping ' +
      formatRupees(gift.threshold) +
      '+. No need to remove it!</p>' +
      '</div>';

    root.appendChild(overlay);
    requestAnimationFrame(function () {
      overlay.classList.add('free-gift-modal--visible');
    });

    function dismiss() {
      overlay.classList.remove('free-gift-modal--visible');
      setTimeout(function () {
        overlay.remove();
      }, 250);
    }

    overlay.querySelectorAll('[data-free-gift-dismiss]').forEach(function (el) {
      el.addEventListener('click', dismiss);
    });
  }

  // ---- Sync -----------------------------------------------------------

  function syncGifts() {
    if (syncInProgress) {
      pendingResync = true;
      return;
    }
    syncInProgress = true;

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var subtotal = computeQualifyingSubtotal(cart);
        var toAdd = [];
        var toRemoveKeys = [];

        GIFTS.forEach(function (gift) {
          var cartLine = cart.items.find(function (item) {
            return item.variant_id === gift.variantId;
          });
          var earned = subtotal >= gift.threshold;

          if (earned && !cartLine) {
            toAdd.push(gift);
          } else if (!earned && cartLine) {
            toRemoveKeys.push(cartLine.key);
          }
        });

        if (toAdd.length === 0 && toRemoveKeys.length === 0) {
          return null;
        }

        var chain = Promise.resolve();

        toRemoveKeys.forEach(function (key) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 }),
            });
          });
        });

        toAdd.forEach(function (gift) {
          chain = chain.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: gift.variantId, quantity: 1 }] }),
            });
          });
        });

        return chain.then(function () {
          return { addedGifts: toAdd, subtotalAfter: subtotal };
        });
      })
      .then(function (result) {
        syncInProgress = false;

        if (result) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE });
          }
          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: { source: SOURCE } })
          );

          if (result.addedGifts.length > 0) {
            var unlockedSoFar = GIFTS.filter(function (gift) {
              return result.subtotalAfter >= gift.threshold;
            });
            showCelebration(unlockedSoFar);
          }
        }

        if (pendingResync) {
          pendingResync = false;
          syncGifts();
        }
      })
      .catch(function () {
        syncInProgress = false;
        pendingResync = false;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    GIFTS = loadConfig();
    if (GIFTS.length === 0) return;

    syncGifts();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === SOURCE) return;
        syncGifts();
      });
    }

    document.addEventListener('cart:updated', function (event) {
      if (event && event.detail && event.detail.source === SOURCE) return;
      syncGifts();
    });
  });

  document.addEventListener(
    'click',
    function (event) {
      var removeButton = event.target.closest('cart-remove-button');
      if (!removeButton) return;

      var variantIdEl = removeButton.querySelector('[data-variant-id]');
      if (!variantIdEl) return;

      // Only the specific line Shopify actually discounted is protected --
      // a second, full-price line of the same variant (a real purchase)
      // removes normally. The template sets this flag per-line based on
      // that line's own original_line_price vs final_line_price.
      if (variantIdEl.dataset.freeGift !== 'true') return;

      var variantId = parseInt(variantIdEl.dataset.variantId, 10);
      var gift = GIFTS.find(function (g) {
        return g.variantId === variantId;
      });
      if (!gift) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      showCantRemoveInfo(gift);
    },
    true
  );
})();
